import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { fetchRecipe, clearCurrentRecipe, updateRecipe } from '../../store/recipesSlice';
import { RecipeFormData } from './RecipeForm';
import useCsrfToken from '../../hooks/useCsrfToken';
import { useNavigate, useParams } from 'react-router-dom';
import RecipeForm from './RecipeForm';
import { fetchIngredients } from '../../store/ingredientsSlice';

const EditRecipeForm: React.FC = () => {
  const dispatch = useAppDispatch();
  const csrfToken = useCsrfToken();
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { currentRecipe: recipe, currentStatus: status } = useAppSelector((state) => state.recipes);

  const [formData, setFormData] = useState<RecipeFormData>({
    name: '', description: '', instructions: '', ingredients_attributes: [], visibility: 'private',
  });

  useEffect(() => {
    dispatch(fetchIngredients({ perPage: 9999 }));
    if (id) dispatch(fetchRecipe(Number(id)));
    return () => { dispatch(clearCurrentRecipe()); };
  }, [id, dispatch]);

  useEffect(() => {
    if (recipe) {
      setFormData({
        name: recipe.name,
        description: recipe.description,
        instructions: recipe.instructions,
        ingredients_attributes: recipe.ingredients,
        visibility: recipe.visibility,
      });
    }
  }, [recipe]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    dispatch(updateRecipe({ id: Number(id), data: formData, csrfToken }))
      .unwrap()
      .then(() => navigate(`/recipes/${id}`))
      .catch((err: Error) => alert('Failed to update recipe: ' + err.message));
  };

  if (status === 'loading' || status === 'idle') {
    return <div className="text-army-600 py-12 text-center">Loading...</div>;
  }
  if (status === 'failed' || !recipe) {
    return <div className="text-rose-400 py-12 text-center">Recipe not found.</div>;
  }

  return (
    <div className="max-w-2xl mx-auto">
      <h2 className="text-2xl font-bold text-white mb-6">Edit Recipe</h2>
      <RecipeForm
        formData={formData}
        setFormData={setFormData}
        onSubmit={handleSubmit}
        submitButtonText="Save Changes"
      />
    </div>
  );
};

export default EditRecipeForm;
